import * as React from 'react';

import { HandleCompanyPreferencesRequire } from '~/components/CompanyPreferences/components/HandleCompanyPreferencesRequire';

export const HandleCompanyPreferences: React.FC = () => {
  return (
    <>
      <HandleCompanyPreferencesRequire />
    </>
  );
};
